import DOMPurify from 'dompurify';

export default {
  methods: {
    sanitizedContent(dynamicContent) {
      return DOMPurify.sanitize(dynamicContent);
    },
  },
};
